export enum SupplierCreditNoteMappingType {
  SUPPLIER_INVOICE = 'supplierInvoice',
  SUPPLIER_INVOICE_ITEM = 'supplierInvoiceItem',
  CLIENT_INVOICE = 'clientInvoice',
  CLIENT_INVOICE_ITEM = 'clientInvoiceItem',
  CLIENT_CREDIT_NOTE = 'clientCreditNote',
}
